/* eslint-disable react-hooks/exhaustive-deps */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-19 11:39:10
 *
 *******************************************************/
// @flow
import React from 'react';
import { withI18n } from '@shopify/react-i18n';
import { Layout, Card, Badge, Icon } from '@shopify/polaris';

import { MagicIcon } from 'src/components/containers/common/icon';
import TransformExperienceWithAI from 'src/assets/images/landing-page/ai-powered/transform-experience-with-ai.png';

const BoostBanner = props => {
  const { i18n } = props;
  return (
    <Layout.Section>
      <div className="section-content transform-data-content">
        <Card>
          <div className="card-content">
            <Badge>
              <Icon source={MagicIcon} />
              <span>{i18n.translate('AdminHTML.LandingPage.AIPowered.aIPowered')}</span>
            </Badge>
            <p className="title">
              {i18n.translate('AdminHTML.LandingPage.AIPowered.transformData_Title')}
            </p>
            <p className="content">
              {i18n.translate('AdminHTML.LandingPage.AIPowered.transformData_Content')}
            </p>
          </div>
          <img
            className="full-width"
            src={TransformExperienceWithAI}
            alt={i18n.translate('AdminHTML.LandingPage.AIPowered.transformData_Title')}
          />
        </Card>
      </div>
    </Layout.Section>
  );
};

export default withI18n()(BoostBanner);
